import "./App.css";
import StudentsList from "./components/StudentsList";
function App() {
  return (
    <>
      <StudentsList></StudentsList>
    </>
  );
}

export default App;
